import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";

/*Fix this*/
import { TextField } from "@material-ui/core";
import axios from "axios";
import "../../profiles/profileComponents/ProfileSettings.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    minWidth: 120,
  },
}));
export default function AgentPersonalInfo(props) {

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const UpdateAgent = async (row) => {
    try {
      const AgentRequestDTO = {
        IdAgent: row.idAgent,
        Enable: row.enable,
        DontXferPlayerActivity: row.dontXferPlayerActivity,
        IsDistributor: row.isDistributor,
        Distributor: row.distributor,
        CommSports: row.commSports,
        CommCasino: row.commCasino,
        CommHorses: row.commHorses,
        IdAgentType: row.idAgentType,
        IdCurrency: row.idCurrency,
        IdBook: row.idBook,
        IdGrouping: row.idGrouping,
        Agent1: row.agent,
        Name: row.name,
        Password: row.password,
        City: row.city,
        State: row.state,
        Country: row.country,
        Address1: row.address1,
        Address2: row.address2,
        Email: row.email,
        Phone: row.phone,
        Fax: row.fax,
        Zip: row.zip,
        OnlineAccess: row.onlineAccess,
        OnlineMessage: row.onlineMessage,
        IdLineType: row.idLineType,
        IdAgentPerHead: row.idAgentPerHead,
        IdLanguage: row.idLanguage,
        LastModificationUser: userInfo.userId,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API2_URL}/Agent/Agent_Update`,
        AgentRequestDTO
      );

      if (response.data === -1) {
        alert("Data Successfully Updated");
      }

      props.getAgentInfo();

    } catch (error) {
      console.error("Error updating agent:", error);
    }
  };

  const handleUpdate = () => {
    UpdateAgent(localAgent);
  };

  const [localAgent, setLocalAgent] = useState(props.AgentInfo || {});

  const handleChange = (event, key) => {
    const value = event.target.value;

    setLocalAgent((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleUpdate();
    }
  };


  useEffect(() => {
    if (props.AgentInfo) {
      setLocalAgent(props.AgentInfo);
    }
  }, [props.AgentInfo]);

  return (
    <>
      <div className="vertical-options">
        <h3>Personal Info</h3>
        <TextField
          size="small"
          type="text"
          label="Address"
          value={localAgent?.address1 || ""}
          onChange={(event) => handleChange(event, "address1")}
          onKeyDown={(e) => handleKeyDown(e, "address1")}
          variant="outlined"
        />
        <TextField
          size="small"
          type="text"
          value={localAgent?.address2 || ""}
          onChange={(event) => handleChange(event, "address2")}
          //onBlur={(event) => handleUpdate(event, "Address2")}
          onKeyDown={(e) => handleKeyDown(e, "address2")}
          variant="outlined"
        />

        <div className="flex flex-row gap-4">
          <TextField
            size="small"
            type="text"
            label="City"
            value={localAgent?.city || ""}
            onChange={(event) => handleChange(event, "city")}
            //onBlur={(event) => handleUpdate(event, "City")}
            onKeyDown={(e) => handleKeyDown(e, "city")}
            variant="outlined"
          />
          <TextField
            size="small"
            type="text"
            label="State"
            value={localAgent?.state || ""}
            onChange={(event) => handleChange(event, "state")}
            //onBlur={(event) => handleUpdate(event, "State")}
            onKeyDown={(e) => handleKeyDown(e, "state")}
            variant="outlined"
          />
          <TextField
            size="small"
            type="text"
            label="Zip"
            value={localAgent?.zip || ""}
            onChange={(event) => handleChange(event, "zip")}
            //onBlur={(event) => handleUpdate(event, "zip")}
            onKeyDown={(e) => handleKeyDown(e, "zip")}
            variant="outlined"
          />
        </div>

        <div className="flex flex-row gap-4">
          <TextField
            size="small"
            type="text"
            label="Country"
            value={localAgent?.country || ""}
            onChange={(event) => handleChange(event, "country")}
            //onBlur={(event) => handleUpdate(event, "Country")}
            onKeyDown={(e) => handleKeyDown(e, "country")}
            variant="outlined"
          />
          <TextField
            size="small"
            type="text"
            label="Phone"
            value={localAgent?.phone || ""}
            onChange={(event) => handleChange(event, "phone")}
            //onBlur={(event) => handleUpdate(event, "Phone")}
            onKeyDown={(e) => handleKeyDown(e, "phone")}
            variant="outlined"
          />
          <TextField
            size="small"
            type="text"
            label="Fax"
            value={localAgent?.fax || ""}
            onChange={(event) => handleChange(event, "fax")}
            //onBlur={(event) => handleUpdate(event, "Fax")}
            onKeyDown={(e) => handleKeyDown(e, "fax")}
            variant="outlined"
          />
        </div>
        <div className="flex flex-row gap-4">
          <TextField
            size="small"
            type="text"
            label="E-mail"
            value={localAgent?.email || ""}
            onChange={(event) => handleChange(event, "email")}
            //onBlur={(event) => handleUpdate(event, "Email")}
            onKeyDown={(e) => handleKeyDown(e, "email")}
            variant="outlined"
          />
        </div>
        <div className="flex flex-row gap-4">
          <TextField
            size="small"
            type="text"
            label="Online Message"
            value={localAgent?.onlineMessage || ""}
            onChange={(event) => handleChange(event, "onlineMessage")}
            //onBlur={(event) => handleUpdate(event, "OnlineMessage")}
            onKeyDown={(e) => handleKeyDown(e, "onlineMessage")}
            inputProps={{ maxLength: 150 }}
            variant="outlined"
          />
        </div>

      </div>
    </>
  );
}
